import { styled } from '@mui/material';

export const Wrapper = styled('div')`
  line-height: 24.8px;
  text-align: left;
`;
